var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("QpeTooltip", {
    scopedSlots: _vm._u([
      {
        key: "hovered_item",
        fn: function() {
          return [
            !_vm.is_hide_menu_child
              ? _c(
                  "v-btn",
                  { attrs: { icon: "" }, on: { click: _vm.toggle_menu } },
                  [
                    _c("v-icon", { attrs: { color: "white" } }, [
                      _vm._v("icon-close")
                    ])
                  ],
                  1
                )
              : _c(
                  "v-btn",
                  {
                    staticClass: "hide-menu-btn__content",
                    attrs: { icon: "" },
                    on: { click: _vm.toggle_menu }
                  },
                  [_c("v-icon", [_vm._v("icon-menu")])],
                  1
                )
          ]
        },
        proxy: true
      },
      {
        key: "tooltip_content",
        fn: function() {
          return [
            _c("span", [_vm._v(_vm._s(_vm.$t("__toggle_menu_btn.hint_text")))])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }